import React from "react";
import { Switch } from "react-router-dom";
import { TestPage, LoginPage, ResultatPage } from "./pages";
import Correction from "./pages/Correction";
import PrivateRoute from "./guards/PrivateRoute";
import TermsOfUse from "./pages/TermsOfUse";
import IntroductionPage from "./pages/IntroductionPage";
import Layout from "./components/Layout";

const Router: React.FC = () => {
  return (
    <Switch>
      <PrivateRoute loginPage={true} exact path="/" component={LoginPage} />
      <PrivateRoute
        loginPage={true}
        exact
        path="/terms"
        component={TermsOfUse}
      />
      <Layout>
        <PrivateRoute
          loginPage={false}
          exact
          path="/test"
          component={TestPage}
        />
        <PrivateRoute
          loginPage={false}
          exact
          path="/correction"
          component={Correction}
        />
        <PrivateRoute
          loginPage={false}
          exact
          path="/resultat"
          component={ResultatPage}
        />
        <PrivateRoute
          loginPage={false}
          exact
          path="/introduction"
          component={IntroductionPage}
        />
      </Layout>
    </Switch>
  );
};

export default Router;
